import { NgModule } from '@angular/core';
import { LoaderComponent } from './loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [LoaderComponent],
  imports: [
    MatProgressSpinnerModule
  ],
  exports: [LoaderComponent]
})
export class IFLoaderModule {}
